import { Box } from "@mui/material";
import HeaderComponent from "./header-component";
import FooterComponent from "./footer-component";
import PropTypes from "prop-types";

const ErrorLayout = ({ children, isError }) => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <Box sx={{ flexShrink: 0 }}>
        <HeaderComponent isError={isError} />
      </Box>

      {/* ONLY this section scrolls */}
      <Box
        component="main"
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* Makes footer stay at bottom when content is short */}
        <Box
          sx={{
            minHeight: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Content */}
          <Box
            sx={{
              flex: 1,
              px: 2,
              pt: { xs: 14, sm: 12, md: 12 },
              pb: 3,
            }}
          >
            {children}
          </Box>

          {/* Footer */}
          <Box
            sx={{
              flexShrink: 0,
              width: "100%",
            }}
          >
            <FooterComponent />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

ErrorLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isError: PropTypes.bool,
};

export default ErrorLayout;
